import React from 'react';
import { FundCard, FundCardProps } from './FundCard';

export const FundCardController: React.VFC<FundCardProps> = (props) => {
  return <FundCard {...props} />;
};
